

/// <reference path="LegalEntityPaymentInstallment.ts" />

// Generated class ProxyPaymentInstallment_ManagedObject

class ProxyPaymentInstallment_ManagedObject extends LegalEntityPaymentInstallment
{

    // Property: currencyReference
    set currencyReference(value:string) {
        this.setValueForKey(value, 'currencyReference');
    }
    get currencyReference():string {
        return this.valueForKey('currencyReference');
    }
    set currencyReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'currencyReference');
    }
    get currencyReferencePrimitiveValue():string {
        return this.primitiveValueForKey('currencyReference');
    }

    // Property: grossAmount
    set grossAmount(value:number) {
        this.setValueForKey(value, 'grossAmount');
    }
    get grossAmount():number {
        return this.valueForKey('grossAmount');
    }
    set grossAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'grossAmount');
    }
    get grossAmountPrimitiveValue():number {
        return this.primitiveValueForKey('grossAmount');
    }

    // Property: merchantName
    set merchantName(value:string) {
        this.setValueForKey(value, 'merchantName');
    }
    get merchantName():string {
        return this.valueForKey('merchantName');
    }
    set merchantNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'merchantName');
    }
    get merchantNamePrimitiveValue():string {
        return this.primitiveValueForKey('merchantName');
    }

    // Property: merchantReference
    set merchantReference(value:string) {
        this.setValueForKey(value, 'merchantReference');
    }
    get merchantReference():string {
        return this.valueForKey('merchantReference');
    }
    set merchantReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'merchantReference');
    }
    get merchantReferencePrimitiveValue():string {
        return this.primitiveValueForKey('merchantReference');
    }

    // Property: merchantSchema
    set merchantSchema(value:string) {
        this.setValueForKey(value, 'merchantSchema');
    }
    get merchantSchema():string {
        return this.valueForKey('merchantSchema');
    }
    set merchantSchemaPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'merchantSchema');
    }
    get merchantSchemaPrimitiveValue():string {
        return this.primitiveValueForKey('merchantSchema');
    }

    // Property: netAmount
    set netAmount(value:number) {
        this.setValueForKey(value, 'netAmount');
    }
    get netAmount():number {
        return this.valueForKey('netAmount');
    }
    set netAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'netAmount');
    }
    get netAmountPrimitiveValue():number {
        return this.primitiveValueForKey('netAmount');
    }

    // Property: paymentFee
    set paymentFee(value:number) {
        this.setValueForKey(value, 'paymentFee');
    }
    get paymentFee():number {
        return this.valueForKey('paymentFee');
    }
    set paymentFeePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'paymentFee');
    }
    get paymentFeePrimitiveValue():number {
        return this.primitiveValueForKey('paymentFee');
    }

    // Property: transactionFee
    set transactionFee(value:number) {
        this.setValueForKey(value, 'transactionFee');
    }
    get transactionFee():number {
        return this.valueForKey('transactionFee');
    }
    set transactionFeePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'transactionFee');
    }
    get transactionFeePrimitiveValue():number {
        return this.primitiveValueForKey('transactionFee');
    }
}
